// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as View from "../../primitives/View.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  main: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1t20fxh",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    $$css: "wino-gc:src/resources/navigation/TextLink.res.js:13"
  },
  highlighted: {
    "color-kMwMTN": "color-x1lewwgq",
    $$css: "wino-gc:src/resources/navigation/TextLink.res.js:18"
  },
  hovered: {
    "color-kMwMTN": "color-x1lewwgq",
    "textDecorationLine-kMnn75": "textDecorationLine-xujl8zx",
    $$css: "wino-gc:src/resources/navigation/TextLink.res.js:21"
  }
};
function styleFromParams(highlighted, hovered) {
  return Stylex.props(styles.main, highlighted ? hovered ? styles.hovered : styles.highlighted : hovered ? styles.hovered : {});
}
function colorFromParams(highlighted, hovered) {
  if (highlighted || hovered) {
    return "#a01e72";
  } else {
    return "#25243a";
  }
}
function TextLink(props) {
  let icon = props.icon;
  let __highlighted = props.highlighted;
  let __openNewTab = props.openNewTab;
  let text = props.text;
  let openNewTab = __openNewTab !== undefined ? __openNewTab : false;
  let highlighted = __highlighted !== undefined ? __highlighted : false;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let ref = match[0];
  let tmp;
  if (icon !== undefined) {
    let newrecord = {
      ...{
        style: {
          display: "flex"
        }
      }
    };
    newrecord.ref = Primitive_option.some(ref);
    let newrecord$1 = {
      ...styleFromParams(highlighted, hovered)
    };
    newrecord.children = [JsxRuntime.jsx("span", (newrecord$1.children = text, newrecord$1)), JsxRuntime.jsx(Box.make, {
      spaceRight: "xsmall"
    }), JsxRuntime.jsx(LegacyIcon.make, {
      name: icon,
      fill: colorFromParams(highlighted, hovered),
      size: 14
    })];
    tmp = JsxRuntime.jsxs(View.make, newrecord);
  } else {
    let newrecord$2 = {
      ...styleFromParams(highlighted, hovered)
    };
    tmp = JsxRuntime.jsx("span", (newrecord$2.ref = Primitive_option.some(ref), newrecord$2.children = text, newrecord$2));
  }
  return JsxRuntime.jsx(Navigation.Link.make, {
    children: tmp,
    to: props.to,
    openNewTab: openNewTab,
    onPress: props.onPress
  });
}
let make = TextLink;
export { make };
/* styles Not a pure module */